export type Currency = 'INR' | 'USD' | 'EUR';

export const CURRENCY_SYMBOL: Record<Currency, string> = { INR: '₹', USD: '$', EUR: '€' };

export function formatMoney(n: number | string | null | undefined, currency: Currency): string {
  const v = typeof n === 'number' ? n : Number(n ?? 0);
  const locale = currency === 'INR' ? 'en-IN' : 'en-US';
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(v);
}

export function formatMoneyWithSymbol(
  n: number | string | null | undefined,
  currency: Currency
): string {
  return `${CURRENCY_SYMBOL[currency]}${formatMoney(n, currency)}`;
}

export function formatDate(s: string | Date | null | undefined): string {
  if (!s) return '-';
  const d = typeof s === 'string' ? new Date(s) : s;
  return d.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
}

export function formatDateTime(s: string | Date | null | undefined): string {
  if (!s) return '-';
  const d = typeof s === 'string' ? new Date(s) : s;
  return d.toLocaleString('en-GB', {
    day: '2-digit', month: 'short', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
  });
}

export function formatRelative(s: string | Date | null | undefined): string {
  if (!s) return '-';
  const d = typeof s === 'string' ? new Date(s) : s;
  const diff = Date.now() - d.getTime();
  const min = Math.round(diff / 60_000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min}m ago`;
  const hr = Math.round(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.round(hr / 24);
  if (day < 30) return `${day}d ago`;
  return formatDate(d);
}
